import { CKBadge, CKLayoutHorizontal } from 'clearkit';

import { ChartEmptyOverlay } from '~/components/ChartEmptyOverlay';

import { GridList } from '../unified/GridList';
import { SettingsCard } from '../unified/SettingsCard';
import { BillingPeriod, useApiUsageData } from './useApiUsageData';

export const APIUsageReport = () => {
  const { billingPeriodCounts } = useApiUsageData();

  return (
    <SettingsCard className="max-w-full">
      <SettingsCard.Header>
        <SettingsCard.Heading>Current Period Usage</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body>
        <ChartEmptyOverlay showEmptyState={!billingPeriodCounts.length}>
          <GridList
            className="space-y-4 min-h-[15rem]"
            gridTemplateColumns="repeat(auto-fit, minmax(11rem, 1fr)"
          >
            <GridList.Header>
              <div>Plan</div>
              <div>Period Ends</div>
              <div>Requests</div>
            </GridList.Header>
            {billingPeriodCounts.map((period: BillingPeriod) => {
              const displayEndDate = new Date(
                period.endTime,
              ).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              });

              return (
                <GridList.Item key={period.planId}>
                  <CKLayoutHorizontal gap=".5rem" justifyContent="start">
                    {period.planName}{' '}
                    <CKBadge>{period.limitTerm ?? 'Monthly'}</CKBadge>
                  </CKLayoutHorizontal>
                  <div>{displayEndDate}</div>
                  <div>
                    {period.count} of {period.limit.toLocaleString('en-us')}
                  </div>
                </GridList.Item>
              );
            })}
          </GridList>
        </ChartEmptyOverlay>
      </SettingsCard.Body>
    </SettingsCard>
  );
};
